module.exports = __webpack_public_path__ + "img/company-icon-small.15d46383.svg";